<template>

    <inertia-link :href="route('contact')"
                  class="position-fixed bg-primary text-white d-flex flex-column justify-content-center align-items-center support-button"
                  style="bottom: 0; right: 0; width: 90px; height: 90px; z-index: 10000000;"
                  data-bs-toggle="modal@todo" 
                  data-bs-target="#exampleModal">
        <img src="/img/icons/headphones-customer-support-human@2x.svg" alt="" class="img-fluid" />
        <div class="text-uppercase small">
            {{ __('Support') }}
        </div>
    </inertia-link>

</template>


<script>
    export default {
        props: {
        },
        data() {
            return {

            }
        }
    }
</script>